// extracted by mini-css-extract-plugin
export var askAiIcon = "_lj-j";
export var category = "_lj-9";
export var categoryHeader = "_lj-e";
export var container = "_lj-0";
export var group = "_lj-a";
export var groupItems = "_lj-f";
export var groupSeparator = "_lj-k";
export var loading = "_lj-1";
export var noResults = "_lj-3";
export var placeholder = "_lj-2";
export var resultContent = "_lj-5";
export var resultIcon = "_lj-c";
export var resultItem = "_lj-g";
export var resultMeta = "_lj-8";
export var resultSubtitle = "_lj-7";
export var resultSuffix = "_lj-i";
export var resultTitle = "_lj-6";
export var resultsList = "_lj-4";
export var searchGroup = "_lj-d";
export var selected = "_lj-h";
export var subgroup = "_lj-b";